import { FormGroup } from '@angular/forms';
import DateHandler from './dateHandler';

export default class FormControl {

  constructor(private formGroup: FormGroup) { }

  setValidationErrorByControlName(controlName: string, validatorType: string) {
    const control = this.formGroup.get(controlName);
    const validator = {};
    validator[validatorType] = true;
    control.setErrors(validator);
    control.markAsTouched();
  }

  clearValidatorErrorByControlName(controlName: string, validatorType: string) {
    const control = this.formGroup.get(controlName);
    const validator = {};
    validator[validatorType] = false;
    control.setErrors(validator);
    control.updateValueAndValidity();
  }

  setValueByControlName(controlName: string, value: any) {
    this.formGroup.get(controlName).setValue(value === null ? '' : value);
  }

  getValueByControlName(controlName: string): string {
    return this.formGroup.get(controlName).value;
  }

  getNumberByControlName(controlName: string): number {
    return +this.formGroup.get(controlName).value;
  }

  getBooleanByControlName(controlName: string): boolean {
    const value = this.getValueByControlName(controlName);
    return value === null || value.length === 0 ? false : Boolean(value);
  }

  getCrimBooleanByControlName(controlName: string): string {
    const value = this.getValueByControlName(controlName);
    const boolean = value === null || value.length === 0 ? 'false' : Boolean(value);
    return boolean ? 'o' : '';
  }

  getDateByControlName(controlName: string, baseCentury: number = 2000): Date {
    const value = this.getValueByControlName(controlName);
    const date = new DateHandler(value, baseCentury);
    return value === null || value.length === 0 || !date.isValid ? null : new Date(date.format());
  }

  getShortDateByControlName(controlName: string, baseCentury: number = 2000): Date {
    const value = this.getValueByControlName(controlName);
    const date = new DateHandler(value, baseCentury);
    return value === null || value.length === 0 || !date.isValid ? null : new Date(Date.UTC(new Date(date.format()).getFullYear(), new Date(date.format()).getMonth(), new Date(date.format()).getDate(), 0, 0, 0, 0));
  }

  getControlByControlName(controlName: string) {
    return this.formGroup.get(controlName);
  }

  hasErrorByControlName(controlName: string): boolean {
    return this.formGroup.get(controlName).invalid;
  }

  isControlNameDirty(controlName: string): boolean {
    return this.formGroup.get(controlName).dirty;
  }

  disableControlByControlName(controlName: string) {
    return this.formGroup.get(controlName).disable();
  }

  enableControlByControlName(controlName: string) {
    return this.formGroup.get(controlName).enable();
  }

  hasValueByControlName(controlName: string) {
    const value = this.getValueByControlName(controlName);
    return value !== null && value !== undefined && value !== '';
  }
}



// WEBPACK FOOTER //
// ./src/models/formControl.ts